module.exports = __webpack_public_path__ + "lemon.jpg?9358b0c0e36422bff39c23b9db338365";